import { LayoutModule } from '../../../../layout/modules';
import PersonIcon from '@mui/icons-material/Person';
import { useSarlaftDetail } from './hook';
import { SarlaftDetailActions } from './actions';
import { SarlaftAccountInfo } from './accountInfo';
import { SarlaftRegisterHistory } from './registerHistory';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isOnlyViewProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';

export const SarlaftDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { sarlaft, loading } = useSarlaftDetail();

    const additionalButtons =
        !isSupervisor(type) && !isOnlyViewProfile(type) ? (
            <SarlaftDetailActions sarlaftId={sarlaft?.id || ''} />
        ) : undefined;

    return (
        <>
            <LayoutModule
                title="Detalle caso SARLAFT"
                titleChildren="Detalle cuenta"
                icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={additionalButtons}
            >
                <SarlaftAccountInfo
                    account={sarlaft?.account}
                    loading={loading}
                />
            </LayoutModule>
            <SarlaftRegisterHistory sarlaft={sarlaft} />
        </>
    );
};
